import React from 'react';
import UniversalCard from '../../../shared/UniversalCard';
import './LeaseExpirationCard.scss';
import MockDataWrapper from '../../../shared/MockDataWrapper';

interface LeaseExpirationData {
  id: string;
  expirationDate: string;
  possibilityOfExtension: boolean;
  unitNumber: string;
  address: string;
}

interface LeaseExpirationCardProps {
  data?: LeaseExpirationData[];
  className?: string;
}

// Моковые данные по умолчанию
const mockLeaseData: LeaseExpirationData[] = [
  {
    id: '1',
    expirationDate: '2025-11-21',
    possibilityOfExtension: true,
    unitNumber: '184',
    address: '314 Rue de Montceau, Laval, QC H7N 1E9, Canada',
  },
  {
    id: '2',
    expirationDate: '2025-11-15',
    possibilityOfExtension: false,
    unitNumber: '205',
    address: '1250 Boulevard Laval, Laval, QC H7S 2L2, Canada',
  },
  {
    id: '3',
    expirationDate: '2026-01-30',
    possibilityOfExtension: true,
    unitNumber: '97',
    address: '892 Rue Saint-Martin, Laval, QC H7M 1Y8, Canada',
  },
];

// Иконка календаря
const calendarIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z"
      fill="currentColor"
    />
  </svg>
);

// Функция рендера содержимого карточки истечения аренды
const renderLeaseExpirationContent = (item: any) => {
  const lease = item as LeaseExpirationData;

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-CA').replace(/-/g, '-');
  };

  return (
    <>
      <div className="LeaseExpirationCard__date">
        {formatDate(lease.expirationDate)}
      </div>

      <div className="LeaseExpirationCard__details">
        {/* Possibility of extension */}
        <div className="LeaseExpirationCard__detail">
          <div className="LeaseExpirationCard__detail-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 1V3M8 4V6M13 7H3M4.22 3H11.78C12.45 3 13 3.55 13 4.22V12.78C13 13.45 12.45 14 11.78 14H4.22C3.55 14 3 13.45 3 12.78V4.22C3 3.55 3.55 3 4.22 3Z"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="LeaseExpirationCard__detail-label">
            Possibility of extension:
          </span>
          <span className="LeaseExpirationCard__detail-value">
            {lease.possibilityOfExtension ? 'Yes' : 'No'}
          </span>
        </div>

        {/* Unit */}
        <div className="LeaseExpirationCard__detail">
          <div className="LeaseExpirationCard__detail-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="7" stroke="#105E96" />
              <path
                d="M8 11.5v-3.5M8 4.5h.01"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="LeaseExpirationCard__detail-label">Unit:</span>
          <span className="LeaseExpirationCard__detail-value">
            {lease.unitNumber}
          </span>
        </div>

        {/* Address */}
        <div className="LeaseExpirationCard__detail LeaseExpirationCard__detail--address">
          <div className="LeaseExpirationCard__detail-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 6.5C13 10.09 8 14 8 14C8 14 3 10.09 3 6.5C3 4.01 5.49 2 8 2C10.51 2 13 4.01 13 6.5Z"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle
                cx="8"
                cy="6.5"
                r="1.5"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="LeaseExpirationCard__detail-text">
            {lease.address}
          </span>
        </div>
      </div>
    </>
  );
};

const LeaseExpirationCard: React.FC<LeaseExpirationCardProps> = ({
                                                                   data,
                                                                   className = '',
                                                                 }) => {
  // Определяем, используются ли мок-данные
  const isMockData = !data;
  const displayData = data || mockLeaseData;

  return (

      <UniversalCard
        title="Lease Expiration"
        backgroundColor="#FF9C07"
        icon={calendarIcon}
        data={displayData}
        renderContent={renderLeaseExpirationContent}
        className={className}
      />

  );
};

export default LeaseExpirationCard;